'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useBannerUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/banner/internal/useBannerUpsellSlotPlan.js';
import { UPSELL_SLOT_ACCEPTED_LOCATIONS, UPSELL_SLOT_IDS, } from '#pplx/frontend/apps/ask/upsell-slots/UpsellSlotInventory.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const AppBannerUpsell = Dynamic(async () => {
    const { AppBannerUpsell } = await import('#pplx/frontend/apps/ask/upsell-slots/banner/internal/AppBannerUpsell.js');
    return { default: AppBannerUpsell };
});
export const BannerUpsellSlot = ({ callsite, children }) => {
    const plan = useBannerUpsellSlotPlan({
        slotId: UPSELL_SLOT_IDS.banner,
        acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.banner,
        source: {
            source: 'homepage',
            responseChannel: 'upsell_information',
            request: {},
        },
        callsite,
    });
    return _jsx(BannerUpsellSlotRenderer, { plan: plan, children: children });
};
const BannerUpsellSlotRenderer = ({ plan, children }) => {
    if (!plan.show) {
        return _jsx("div", { "data-upsell-slot": UPSELL_SLOT_IDS.banner });
    }
    return (_jsx("div", { "data-upsell-slot": plan.slotId, children: children?.(plan) ?? _jsx(AppBannerUpsell, { ...plan.render.props }) }));
};
//# sourceMappingURL=BannerUpsellSlot.js.map